import { Flex, HStack } from '@chakra-ui/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

import { PrimaryButton } from '~/components/ui/PrimaryButton';

interface NavigationButtonsProps {
  onBack: () => void;
  onContinue: () => void;
  backLabel?: string;
  continueLabel?: string;
}

export const NavigationButtons = ({
  onBack,
  onContinue,
  backLabel = 'Back',
  continueLabel = 'Continue',
}: NavigationButtonsProps) => {
  return (
    <HStack gap={4}>
      <PrimaryButton onClick={onBack} variant="outline">
        <Flex gap={2} align="center">
          <ArrowLeft size={16} />
          <span>{backLabel}</span>
        </Flex>
      </PrimaryButton>
      <PrimaryButton onClick={onContinue} colorScheme="blue">
        <Flex gap={2} align="center">
          <span>{continueLabel}</span>
          <ArrowRight size={16} />
        </Flex>
      </PrimaryButton>
    </HStack>
  );
};
